export default "__VITE_ASSET__a66bc044__"